import { canUseDOM, openWindow } from '@/utils/dom-utils';
import * as querystring from 'querystring';
import {
  eq /* eslint-disable @typescript-eslint/no-unused-vars */,
  _formatString,
} from '@/utils/string-utils';
import { webStorage } from '@/utils/web-storage';
import {
  S_LANG /* eslint-disable @typescript-eslint/no-unused-vars */,
  _S_LOGIN_INFO,
} from '@/utils/web-storage-keys';
/* eslint-disable @typescript-eslint/no-unused-vars */
import _config from '@/temp/config';
import { isNoW } from '@/utils/obj-utils';
import { getGlobalConfigs } from '@/utils/site-utils';
import { decodeData } from './site-utils';

export const isAbsoluteUri = (url) => {
  return /^(https?:)?\/\//gi.test(url);
};
export const isMailUri = (url) => {
  return /^mailto:/gi.test(url);
};
export const isTelUri = (url) => {
  return /^tel:/gi.test(url);
};
// export const getCurrentLang = () => {
//   return; //
// };
export const getQueryStrings = (...args) => {
  const result = [];
  const queries = canUseDOM() ? querystring.parse(window.location.search.substring('1')) : {};
  for (let arg of args) {
    const keys = Object.keys(queries);
    let value = null;
    for (let key of keys) {
      if (eq(arg, key)) {
        value = queries[key];
        break;
      }
    }
    result.push(value);
  }
  return result;
};
export const getQueryDataList = (...args) => {
  const items = getQueryStrings(...args);
  return items.map((x) => decodeData(x));
};
export const appendQuery = (url, _params, removeParams) => {
  if (!url) return null;
  const arr = url.split('?');
  let query = {};
  let path = url;
  if (arr.length === 1) {
    query = _params;
  } else {
    path = arr[0];
    query = Object.assign(querystring.parse(arr[1]), _params ?? {});
  }
  if (removeParams) {
    removeParams.forEach((p) => {
      if (query[p]) {
        delete query[p];
      }
    });
  }
  return `${path}?${querystring.stringify(query)}`;
};

export const getLocalUrl = (url) => {
  if (!canUseDOM()) return url;
  return `${window.location.origin}${url}`;
};
export const concatUrls = (...urls) => {
  let result = '';
  for (let url of urls) {
    if (isNoW(url)) continue;
    if (result === '') result = url;
    else {
      result = `${result.replace(/[/\\]$/gi, '')}/${url.replace(/^[/\\]/gi, '')}`;
    }
  }
  return result;
};
export const getBetterUrl = (url, defaultLang = null, forceAbsolute = false) => {
  if (!canUseDOM()) return url;
  if (/http:\/\/(mailto|tel):/gi.test(url)) {
    url = url.replace(/http:\/\//gi, '');
  }
  if (isMailUri(url) || isTelUri(url)) return url;
  if (isNoW(url)) return null;
  let newUrl = url;
  if (!defaultLang) defaultLang = webStorage.get(S_LANG);
  // const loginInfo = webStorage.get(S_LOGIN_INFO);
  // console.log('newUrl', newUrl);
  // newUrl = formatString(
  //   newUrl,
  //   {
  //     access_token: loginInfo?.token
  //   },
  //   null,
  //   true
  // );

  // 注释掉自动添加语言前缀的逻辑，直接返回处理后的URL
  // const reg = /^\/(en|[A-Z]{2}|([a-z]{2}))(\/|$)/gi;
  // if (isAbsoluteUri(newUrl)) {
  //   const uri = new URL(newUrl);
  //   if (!eq(uri.origin, global.location.origin)) return newUrl;
  //   let { pathname } = uri;
  //   if (!reg.test(pathname)) {
  //     pathname = concatUrls(`/${defaultLang}`, pathname);
  //   }
  //   return concatUrls(uri.origin, `${pathname}${uri.search}${uri.hash}`);
  // }
  // if (!reg.test(newUrl)) {
  //   newUrl = concatUrls(`/${defaultLang}`, newUrl);
  // }

  if (forceAbsolute) {
    if (!isAbsoluteUri(newUrl)) {
      newUrl = concatUrls(window.location.origin, newUrl);
    }
  }
  // 只有当URL不是根路径时才移除末尾的斜杠
  if (newUrl !== '/') {
    newUrl = newUrl.replace(/[\\/]$/gi, '');
  }
  return newUrl;
};
export const getLoginUrl = (page) => {
  const [loginUrl] = getUrls(page, 'loginLink');
  return loginUrl;
};
export const getLogoutUrl = (page) => {
  const [logoutUrl] = getUrls(page, 'logoutLink');
  return logoutUrl;
};
export const getUrls = (page, ...linkNames) => {
  const links = getGlobalConfigs(page, ...linkNames);
  return links.map((link) => link?.value?.href);
};
export const redirectTo = ({ url, target = '_self', router, lang }) => {
  url = getBetterUrl(url, lang);
  if (!isAbsoluteUri(url)) {
    if (router?.push) {
      const [path, queryStr] = url.split('?');
      let query = null;
      try {
        query = querystring.parse(queryStr);
      } catch (ex) {
        console.log(ex);
      }

      router.push({ path, query });
      return;
    }
    if (canUseDOM()) {
      url = concatUrls(window.location.origin, url);
    }
  }
  openWindow(url, target);
};
export const redirectToLogin = (page, router) => {
  const url = appendQuery(getLoginUrl(page), {
    redirect_url: window.location.href,
  });
  redirectTo({ url, router });
};
export const redirectToLogout = (page, router) => {
  const url = appendQuery(getLogoutUrl(page));
  redirectTo({ url, router });
};
export const redirectToLang = (lang, router) => {
  if (!canUseDOM()) return;
  const reg = /^\/(en|[A-Z]{2}|([a-z]{2}))(\/|$)/gi;
  const { pathname, search, hash } = window.location;
  // 直接使用不带语言前缀的路径
  const url = `${pathname.replace(reg, '/')}${search}${hash}`;
  redirectTo({ url, router, lang });
};
export const getLangFromUrl = () => {
  if (!canUseDOM()) return 'en';
  const { pathname } = window.location;
  const path = pathname.split('/')[1];
  // 支持语言-地区代码格式（如 en-US, zh-CN）或纯语言代码（如 en, zh）
  const matches = /^[a-z]{2}(-[A-Z]{2})?$/i.exec(path);
  if (matches?.length > 0) {
    return matches[0].toLowerCase();
  }
  // 如果没有语言前缀或格式无效，返回默认语言
  return 'en';
};

export const UnicodeEnc = (str) => {
  let temp = '';
  const strArr = Array.from(str);
  const re = new RegExp('^[0-9a-zA-Z_]+$');
  strArr.forEach((s, i) => {
    if (re.test(s)) {
      temp += s;
    } else {
      temp += ('0000' + parseInt(str.charCodeAt(i)).toString(16)).substr(-4);
    }
  });
  return temp;
};
